<template>
  <vue-scroll class="page-payment-provider">
    <div class="page-header">
      <h1><i :class="'mdi mdi-' + $route.meta.icon"></i> {{ $route.name }}</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="card-base card-shadow--medium p-30">
      <el-row :gutter="50">
        <el-col :span="24">
          <h2>Seguimiento de remisiones aceptadas e impresas</h2>
        </el-col>
        <!-- grid -->
        <el-col :span="24">
          <el-card class="card-shadow--small">
            <el-row :gutter="20">
              <el-col :span="9">
                <el-input
                  placeholder="Número de remision o traslado"
                  v-model="referral"
                  clearable
                  @clear="
                    referral = null;
                    getData();
                  "
                >
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
              </el-col>
              <el-col :span="9">
                <el-select
                  v-model="branch"
                  filterable
                  value-key="id"
                  placeholder="Seleccione la sucursal"
                  clearable
                  @clear="
                    branch = null;
                    getData();
                  "
                >
                  <el-option
                    v-for="item in stores"
                    :key="item.id"
                    :label="item.razon_social"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="6">
                <el-button
                  type="primary"
                  icon="el-icon-search"

                  :loading="loadingFilter"
                  @click="filterTable"
                  >Buscar</el-button
                >
              </el-col>
            </el-row>
          </el-card>
          <el-table
            :data="tableData"
            style="width: 100%; margin-top: 20px"
            height="500"
            v-loading="loading"
          >
            <el-table-column
              label="Documento"
              prop="document.type.descripcion"
            ></el-table-column>
            <el-table-column
              label="Consecutivo"
              prop="document.consecutivo"
            ></el-table-column>
            <el-table-column
              label="Bodega"
              prop="branch.razon_social"
            ></el-table-column>
            <el-table-column
              label="Fecha de impresión"
              prop="printing_date"
              width="300"
            >
              <template slot-scope="scope">
                <pre>{{ gameDateFormat(scope.row.printing_date) }}</pre>
              </template></el-table-column
            >
            <el-table-column
              label="Fecha de aceptación"
              prop="accepted_date"
              width="300"
            >
              <template slot-scope="scope">
                <pre>{{ gameDateFormat(scope.row.accepted_date) }}</pre>
              </template></el-table-column
            >
            <el-table-column align="center" width="100">
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Eliminar"
                  placement="top"
                >
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                    icon="el-icon-delete"
                    :disabled="scope.row.accepted_date !== null"
                    circle
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <div
            v-if="tableData.length > 0"
            class="pagination-box animated fadeInRight"
            style="text-align: end; padding-top: 10px"
          >
            <el-pagination
              layout="total, prev, pager, next"
              :page-size="pageSize"
              :total="total_rows"
              @current-change="handleCurrentPage"
            ></el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </vue-scroll>
</template>

<script>
import { getAll, deleteData } from "@/api/referrals";
import { getAll as getStores } from "@/api/store";
export default {
  name: "Store",
  data() {
    return {
      loading: false,
      loadingFilter: false,
      tableData: [],
      stores: [],
      referral: null,
      branch: null,
      //
      pageSize: 10,
      currentPage: 1,
      total_rows: 0,
    };
  },
  methods: {
    gameDateFormat(date) {
      var options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      if (date !== null) {
        var time = date.substring(19, 10);
        date.replace(" ", "T");
        var fecha = new Date(date);
        return fecha.toLocaleDateString("es-ES", options) + " \nHora:" + time;
      }
    },
    resizeOpenNav() {
      this.innerWidth = window.innerWidth;
    },
    filterTable() {
      this.loadingFilter = true;
      this.getData();
    },
    handleCurrentPage(val) {
      this.getData(val);
    },
    getData(current) {
      this.loading = true;
      if (typeof current == "undefined") {
        if (this.referral != null || this.branch != null) {
          this.currentPage = 1;
        }
      } else {
        this.currentPage = current;
      }
      getAll(this.pageSize, this.currentPage, this.referral, this.branch)
        .then(({ data }) => {
          this.tableData = data.data;
          this.total_rows = data.total;
          this.loading = false;
          this.loadingFilter = false;
        })
        .catch(function (error) {
          this.loadingFilter = false;
          this.loading = false;
          console.log(error);
        });
    },
    handleDelete(index, row) {
      let me = this;
      this.loading = true;
      this.$confirm("Desea eliminar este registro?", "Atención!", {
        confirmButtonText: "Si",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(() => {
          deleteData(row.id)
            .then(({ data }) => {
              this.loading = false;
              if (data.code === 200) {
                this.getData();
                this.resetForm("form");
              } else {
                this.$message.error("Error! " + data.error.errorInfo[2]);
              }
            })
            .catch(function (error) {
              console.log("Err: ", error);
              me.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
          this.$message({
            type: "info",
            message: "Operación Cancelada",
          });
        });
    },
    getStores() {
      getStores()
        .then(({ data }) => {
          this.stores = data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getStores();
  },
  created() {
    this.getData();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeOpenNav);
  },
};
</script>

<style lang="scss">
.el-select {
  width: 100%;
}
.el-icon-circle-check {
  color: #1cc529;
}
</style>
